module.exports = __webpack_public_path__ + "media/images/map/edit-eed62af534437125f38b4c0867a08a0b.svg";